import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import './scss/form.scss';
import UploadImg from '@/pages/components/uploadImg';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import Dialog from '@/pages/components/dialog';
import { PickerBox } from '@/pages/components/picker';
import alert from '@/pages/components/common/alert';
import * as queryString from 'query-string';


interface initProps{
	history: any,
	location: any,
}

class ComponentAuth extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		const query = queryString.parse(this.props.location.search);
		this.state = {
			init: query.init ? `${query.init}` : 0,
			visiblity: false, // 提示按钮
			dialogVisiblity: false, // 认证企业按钮
			status: '', // 审核状态, 
			// 企业分类
			componentsTypeData: {
				displayValue (item: any) {
		        	return item.name;
		    	},
		    	list: [],
			},
			ComponentsDeptData: {
				displayValue (item: any) {
		        	return item.name;
		    	},
		    	list: [],
			},
			form: {
				component_name: '', // 公司名称
				credit_code: '',  // 信用代码
				component_type: '', // 公司分类
				name: '',	// 姓名
				department: '', // 部门
				grade: '',		// 职位
				avart: '',	// 头像
			},
			componentList: [], // 企业列表
			companyId: '', // 企业id
			isSubmiting: false, // 是否提交

		}
	}

	 
	componentDidMount() {
		this.initData();
	}
	

	render() {
		return (
			<div className="gray-bg">
				<Dialog visiblity={this.state.dialogVisiblity}>
					<div className="certified">
						<p className="certified-title">系统已存在认证企业如下</p>
						<div className="form-radio-group">
							{
								this.state.componentList && this.state.componentList.map((v: any, k:any) => {
									return (
										<div className ="radio-item" key={k}>
											<div className="radio-box">
												<input 
													type="radio" 
													name="radio"   
													className="radio" 
													id={`radio${k}`} 
													onChange={(e:any) => { 
														if(e.target.checked) { 
															this.setState({
																companyId: v.companyId,
															})
														}  
													}} />
												<span className="radio-icon"></span>
											</div>
											<label className="radio-text" htmlFor={`radio${k}`}>{v.msg}<span className="gray">{v.manager}</span></label>
										</div>
									)
								})
							}
						</div>
						<p className="prompt">是否申请加入所选企业?</p>
						<div className="button-box">
							<button className="btn sucess" onClick={() => this.joinComponent()}>申请加入企业</button>
							<button className="btn" onClick={() => this.setState({ dialogVisiblity: false, companyId: '' }) }>取消</button>
						</div>
					</div>
				</Dialog>


				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>公司名称</label>
						<input 
							type="text" 
							placeholder="请输入公司名称" 
							className="text-right" 
							value={this.state.form.component_name	}  
							onChange={ (e:any) => this.setForm('component_name', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>社会信用代码</label>
						<input 
							type="text" 
							placeholder="请输入社会信用代码" 
							className="text-right" 
							value={this.state.form.credit_code	}  
							onChange={ (e:any) => this.setForm('credit_code', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>企业分类</label>
						<button 
							className="input-select text-right" 
							data-value={this.state.form.component_type.name ? this.state.form.component_type.name : ''} 
							onClick={() => this.showComponentsType() }>
							{ this.state.form.component_type.name ? this.state.form.component_type.name : '请输入企业分类' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>姓名</label>
						<input 
							type="text" 
							placeholder="请输入姓名" 
							className="text-right" 
							value={this.state.form.name	}  
							onChange={ (e:any) => this.setForm('name', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>所在部门</label>
						<button 
							className="input-select text-right" 
							data-value={this.state.form.department.name ? this.state.form.department.name : ''} 
							onClick={() => this.showComponentsDept() }>
							{ this.state.form.department.name ? this.state.form.department.name : '请输入企业部门' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label">职位</label>
						<input 
							type="text" 
							placeholder="请输入职位" 
							className="text-right" 
							value={this.state.form.grade	}  
							onChange={ (e:any) => this.setForm('grade', e.target.value) }/>
					</div>
					<div className="form-upload-warrper">
						<label className="label">个人名片</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('avart', data)}  id={this.state.form.avart} />
						</div>
					</div>
				</div>
				<div className="form-btn-warrrper">
					<button className="form-btn" onClick={() =>  this.submitForm() }>申请企业认证</button>
				</div>
				<ActionSheet />
			</div>
		)
	}

	// 返回初始化数据
	private async initData() {
		const r = await request({
			method: "get",
			url: `${config.CE}member/company/info`,
		});
		
		if (r.code !== 1) {
			alert.open({
				promptText: r.msg,
			})
		} else {
			const {memberInfo} = r.obj;
			const checkNull = (data: any) => {
				return data ? data : '' 
			}
			
			if(!memberInfo) {
				return ;
			}

			this.setState({
				form: {
					component_name: memberInfo ? checkNull(memberInfo.company) : '', 
					credit_code: memberInfo ? checkNull(memberInfo.licenceCreditCode) : '', 
					component_type: memberInfo ? { name: memberInfo.companyTypeValue, value: checkNull(memberInfo.companyType)  } : '', 
					name: memberInfo ? checkNull(memberInfo.trueName) : '',	
					department: memberInfo ? {name:memberInfo.deptName , value: checkNull(memberInfo.dept)} : '', 
					grade: memberInfo ? checkNull(memberInfo.duty) : '',		
					avart: memberInfo ? checkNull(memberInfo.businessCard) : '',	
				}
			}, () => {
				this.getComponentsType();
				this.getComponentsDept();
			})
		}
	}
	// 企业分类
	private async getComponentsType() {
		// 获取数据
		const r = await request({
	      method: "get",
	      url: `${config.CE}member/info/companyType?flag=1`,
	    });
		if(r.code !== 1) {
			alert.open({
	    		promptText: r.msg,
	    	})
			return;
		}
		this.setState({
			componentsTypeData: {
				...this.state.componentsTypeData,
				list: r.obj
			}
		})
	}
	// 显示企业分类面板
	private showComponentsType() {
		const that = this;
		// 显示弹框
		(PickerBox as any).open({
			data: [{
				...that.state.componentsTypeData
			}],
			valueLable: 'id',

			// 成功回调
			onConfrim: (data: any) => {
				that.setState({
					form: {
						...this.state.form,
						component_type: {
							name: data.name,
							value: data.value,
						},
					}
				})
			}
		})
	}

	// 个人部门
	private async getComponentsDept() {
		// 获取数据
		const r = await request({
	      method: "get",
	      url: `${config.CE}member/info/dept`,
	    });
		if(r.code !== 1) {
			alert.open({
	    		promptText: r.msg,
	    	})
			return;
		}
		this.setState({
			ComponentsDeptData: {
				...this.state.ComponentsDeptData,
				list: r.obj
			}
		})
	}

	// 显示个人部门面板
	private showComponentsDept() {
		const that = this;
		// 显示弹框
		(PickerBox as any).open({
			data: [{
				...that.state.ComponentsDeptData
			}],
			valueLable: 'id',

			// 成功回调
			onConfrim: (data: any) => {
				that.setState({
					form: {
						...this.state.form,
						department: {
							name: data.name,
							value: data.value,
						},
					}
				})
			}
		})
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {

		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	// 检测表单
	private checkForm() {
		const companyNameReg = /[。\/？》《\>\<\~\!\@\#\%\$\%\^\&\*]/
		const companyNameHasNumReg = /\d/
		const compnayNameHasEnglish = /[a-zA-Z]/
		const companyNameChinese = /[\u4e00-\u9fa5]/
		const companyNameHasBlank = /[\r\s]/
		if(!this.state.form.component_name || this.state.form.component_name.trim() === '') {
			return alert.open({
				promptText: '请输入公司名称'
			});
		}
		console.log(companyNameReg, this.state.form.component_name, companyNameReg.test(this.state.form.component_name))
		if (companyNameReg.test(this.state.form.component_name)) {
			return alert.open({
				promptText: '企业名称存在特殊字符，请重新输入！'
			});
		}
		if (companyNameChinese.test(this.state.form.component_name)) {
			if (!compnayNameHasEnglish.test(this.state.form.component_name) && companyNameHasBlank.test(this.state.form.component_name)) {
				return alert.open({
					promptText: '企业名称存在空格，请重新输入'
				});
			}
		}
		if (companyNameHasNumReg.test(this.state.form.component_name)) {
			return alert.open({
				promptText: '企业名称不能存在数字，请重新输入！'
			});
		}

		if(this.state.form.credit_code.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入社会信用代码',
	    	})
			return ;
		} else if(!/^[A-Z\d\-]{18,20}$/.test(this.state.form.credit_code)) {
			return alert.open({
				promptText: '社会信用代码18位到20位，只能包括数字、大写英文字母或-'
			}); 
		}

		if(this.state.form.component_type.value=== undefined || this.state.form.component_type.value.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择企业分类',
	    	})
			return ;
		}

		if(this.state.form.name.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入姓名',
	    	})
			return ;
		}

		if(this.state.form.department.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入所在部门',
	    	})
			return ;
		}

		return true
	}

	// 提交表单
	private async submitForm() {
		if(!this.checkForm()) {
			return ;
		}

		// 防止重复提交
		if(this.state.isSubmiting) {
			return ;
		}

		this.setState({
			isSubmiting: true
		})

		const r = await request({
	      method: "post",
	      url: `${config.CE}member/auth/company/submit/step/0`,
	      data: {
	      	company: this.state.form.component_name ? this.state.form.component_name : '',
	      	licenceCreditCode: this.state.form.credit_code ? this.state.form.credit_code : '',
	      	companyType: this.state.form.component_type.value ? this.state.form.component_type.value : '',
	      	authType: 0,
	      	trueName: this.state.form.name ? this.state.form.name : '',
	      	dept: this.state.form.department.value ? this.state.form.department.value : '',
	      	businessCard: this.state.form.avart ? this.state.form.avart : '',
	      	duty: this.state.form.grade ? this.state.form.grade : ''
	      }
	    });

		this.setState({
			isSubmiting: false,
		})

		// 企业相同
	    if(r.code === 200) {
	    	// this.props.history.push('/auth/step1')
	    	this.setState({
	    		componentList: r.obj,
	    		dialogVisiblity: true,
	    	})

	    	return ;
	    }

	    if(r.code !== 1) {
	    	alert.open({
	    		promptText: r.msg,
	    	})
	    }else {
	    	this.setState({
	    		form: {
					component_name: '', // 公司名称
					credit_code: '',  // 信用代码
					component_type: '', // 公司分类
					name: '',	// 姓名
					department: '', // 部门
					grade: '',		// 职位
					avart: '',	// 头像
				}
	    	}, () => {
	    		this.props.history.push('/auth/step1')
	    	})
	    }
	}


	// 加入企业
	private async joinComponent() {
		const that = this;

		if(String(this.state.companyId).replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择认证企业',
	    	})
			return ;
		}
		const r = await request({
	      method: "post",
	      url: `${config.CE}member/auth/company/join`,
	      data: {
	      	companyId: this.state.companyId,
	      }
	    });

	    if(r.code !== 1) {
	    	alert.open({
	    		promptText: r.msg,
	    	})
	    }else {
	    	this.setState({
	    		companyId: '',
	    		dialogVisiblity: false,
	    	},() => {
	    		alert.open({
		    		promptText: '加入企业成功',
		    		callback: () => {
		    			that.props.history.push('/')
		    		}
		    	})
	    		
	    	})
	    }
	}
}

export default ComponentAuth;